export const environment = {
  production: true,
  base_url: "https://api.naturally-plus.com.tw/naturallyplus/cms",
};



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/environments/environment.ts